import { Navigate } from "react-router-dom"

export function GodCatchAllPage() {
	return <Navigate to="/god" replace />
}
